<template>
  <BusinessProductsBlock
    v-if="products.length"
    ref="$productsBlock"
    :title="$t('components.business.products.ProductsMoreFromThisSeller.title')"
    :products="products"
    :show-more-link="products.length < 8 ? '' : `/profile/${sellerId}`"
    :chapter="chapter"
    :event-options="eventOptions"
  />
</template>

<script setup lang="ts">
import { useApi } from '~/restAPI';
import { Catalog } from '~/restAPI/Catalog';
import { AnalyticsEvents, IEventOptions } from '~/types/analytics';

const chapter = 'seller';

const props = defineProps<{
  sellerId: number
  productId?: number
  eventOptions?: IEventOptions,
}>();

const $productsBlock = ref();

const isVisible = useElementVisibility($productsBlock);
const { createApiInstance } = useApi();
const { $addEvent } = useNuxtApp();

const catalogApi = createApiInstance(Catalog);

const { data } = useLazyAsyncData(() => catalogApi.getCatalogUsingGet({
  sellerId: props.sellerId,
  page: 1,
  pageLength: 9,
}, { format: 'json' }).then((res) => res?.data?.data));

const products = computed(() => {
  const items = (data.value?.items ?? []).filter((item) => item.productId !== props.productId);

  if (items.length < 9) return items;

  return items.splice(0, 8);
});

const unwatch = watch(() => isVisible.value, (value) => {
  if (value) {
    $addEvent(AnalyticsEvents.ProductsBlockView, {
      chapter,
      ...(props.eventOptions?.view ?? []),
    });

    unwatch();
  }
}, { immediate: true });
</script>
